var $$ = $$ || {};

class Application {
	constructor () {

		this._initMainSlider();
		this.initSliderCards();
		this.initProductCards();
		this._initHeader();
		this._initAuth();
		this._initPageNotFound();
		this._initContentSlider();
		this.initFeedbackSliderCards();
		this._initVideoBlocks();
		this._initTabs();
		this._initCart();
		this._initDelivery();
		this._initProfilePage();
		this._initRegistrationPage();
		this._initRegistrationEvent();
		this._initContactsMap();
		this._initCardPage();
		this._initProductCard();
		this._initCatalogMenu();
		this._initFormTabs();
		this._initPartnerForm();
		this._initCollapseBlocks();
		this._initPopup();
		this._initOpenPopup();
		this._initFixedHeader();
		this._initAnchors();
		this._initDeliveryPopup();
		this._initScrollBottomRegistration();

		this._initScrollList();

		this._initAjaxSearch();

		this.initLearnHowToOrder();

		this._mainScripts();

		this._fixIeFormButtons();
		
	}

	_initMainSlider () {
		$('.js-main-slider').each(function () {
			new $$.BannerSlider($(this));
		});
	}

	initSliderCards () {
		$('.js-slider').each(function (index, event) {
			if ( !$(event).data('init-slider') ) {
				$(event).data('init-slider', true);

				new $$.Slider($(this));
			}
		});
	}

	initProductCards () {
		$('.js-not-slider').each(function (index, event) {
			if ( !$(event).data('init-not-slider') ) {
				$(event).data('init-not-slider', true);

				new $$.ProductCards($(this));
			}
		});
	}

	_initHeader () {
		$('.js-header-wrapper').each(function () {
			new $$.Header($(this));
		});
	}

	_initAuth () {
		$('.js-auth').each(function () {
			new $$.Auth($(this));
		});
	}

	_initPageNotFound () {
		$('.js-page-not-found').each(function () {
			new $$.PageNotFound($(this));
		});
	}

	_initContentSlider () {
		$('.js-content-slider').each(function () {
			new $$.ContentSlider($(this));
		});
	}

	initFeedbackSliderCards () {
		$('.js-feedback-slider').each(function (index, event) {
			if ( !$(event).data('init-feedback-slider') ) {
				$(event).data('init-feedback-slider', true);

				new $$.FeedbackSlider($(this));
			}
		});
	}

	_initVideoBlocks () {
		$('.js-video-block').each(function () {
			new $$.VideoBlock($(this));
		});
	}

	_initTabs () {
		$('.js-tabs-handler').each(function () {
			new $$.Tabs($(this));
		});
	}

	_initCart () {
		$('.js-cart').each(function () {
			new $$.Cart($(this));
		});
	}

	_initDelivery () {
		$('.js-delivery').each(function () {
			new $$.Delivery($(this));
		});
	}

	_initProfilePage () {
		$('.js-profile-page').each(function () {
			new $$.ProfilePage($(this));
		});
	}

	_initRegistrationPage () {
		$('.js-registration-page').each(function () {
			new $$.RegistrationPage($(this));
		});
	}

	_initRegistrationEvent () {
		$('.js-registration-event-form').each(function () {
			new $$.RegistrationEvent($(this));
		});
	}

	_initContactsMap () {
		$('.js-contacts-map-wrapper').each(function () {
			new $$.ContactsMap($(this));
		});
	}

	_initCardPage () {
		$('.js-card-page').each(function () {
			new $$.CardPage($(this));
		});
	}

	_initProductCard () {
		$('.js-aside-card').each(function () {
			new $$.ProductCard($(this));
		});
	}

	_initCatalogMenu () {
		$('.js-catalog-menu-wrapper').each(function () {
			new $$.CatalogMenu($(this));
		});
	}

	_initCollapseBlocks () {
		$('.js-collapse-blocks').each(function () {
			new $$.CollapseBlocks($(this));
		});
	}

	_initScrollList () {
		$('.js-scroll-list').each(function () {
			new $$.ScrollList($(this));
		});
	}

	// Форма расчет монтажа
	_initFormTabs () {
		$('.js-form-tabs').each(function () {
			new $$.FormTabs($(this));
		});
	}

	_initPartnerForm () {
		$('.js-partner-form').each(function () {
			new $$.PartnerForm($(this));
		});
	}

	_initAjaxSearch () {
		$('.js-search-wrapper').each(function () {
			new $$.AjaxSearch($(this));
		});
	}

	_initPopup () {
		$('.js-popup').each(function () {
			$$.Popup = new $$.Popup($(this));
		});
	}

	_initOpenPopup () {
		$('.js-open-popup').each(function () {
			new $$.OpenPopup($(this));
		});
	}

	_initFixedHeader () {
		$('.js-fixed-header').each(function () {
			new $$.FixedHeader($(this));
		});
	}

	_initAnchors () {
		$('.js-anchors').each(function () {
			new $$.Anchors($(this));
		});
	}

	_initDeliveryPopup () {
		$('.js-delivery-popup').each(function () {
			new $$.DeliveryPopup($(this));
		});
	}

	_initScrollBottomRegistration () {
		$('.js-scroll-bottom-registration').each(function () {
			new $$.ScrollBottomRegistration($(this));
		});
	}

	initLearnHowToOrder () {
		$('.cards-wrapper .js-feedback').each(function (index, event) {
			if ( !$(event).data('init-cards-feedback') ) {
				$(event).data('init-cards-feedback', true);

				new $$.LearnHowToOrder($(this));
			}
		});
	}

	_mainScripts () {
		"use strict";

		$('.social-likes').each(function () {
			var data = $(this).data()
			$(this).socialLikes({
				url:         location.origin,
				title:       data.title,
				counters:    false,
				singleTitle: ''
			});
		});

		var messages = $('.js-messages');

		var messagesData = messages.data();

		_.each(messagesData, function (value, key) {
			if (_.isBoolean(value)) {
				if (value) {
					$$.Noty[ key ]();
				}
			} else {
				var val = value.split('-');
				if (val[ 0 ] === 'true') {
					$$.Noty[ key ](val[ 1 ], val[ 2 ]);
				}
			}
		});

		$('select').styler();

		$$.initCountGoods();

		$('.jq-selectbox ul').each(function () {
			"use strict";
			$(this).niceScroll({
				cursorcolor:        '#0c64d4',
				cursoropacitymin:   1,
				cursorwidth:        10,
				cursorborder:       'none',
				cursorborderradius: 0,
				cursorfixedheight:  90
			});
		});

		var phoneMask = new Inputmask("8 (999) 999-99-99");

		$('.js-phone-input').each(function () {
			"use strict";

			phoneMask.mask($(this).get(0));
		});

		$('.js-not-found-search-input').each(function () {
			$(this).on('focus', function () {
				$(this).parent().addClass('focus');
			});

			$(this).on('blur', function () {
				$(this).parent().removeClass('focus');
			});
		});

		$('.js-product-cards-tabs').each(function () {
			var tabs = $(this);
			var tab = tabs.find('.js-slider');
			var tabLink = tabs.find('.js-tab-link');

			tab.addClass('hidden');
			tab.first().removeClass('hidden');

			tabLink.on('click', function (event) {
				event.preventDefault();
				var link = $(this);
				tabLink.removeClass('current');
				link.addClass('current');

				tab.removeClass('show');
				tab.addClass('hidden');

				tab.eq(link.index()).removeClass('hidden').addClass('show');

				new $$.Slider(tab.eq(link));
			});
		});

		$('.js-compare-page').each(function () {
			var item = $(this);

			var compareList = item.find('.js-compare-header-list a');
			var products = item.find('.js-products');

			compareList.on('click', function (event) {
				event.preventDefault();
				var compareLink = $(event.currentTarget);
				var index = compareLink.index();

				compareLink.siblings().removeClass('current');
				compareLink.siblings().addClass('dotted');
				compareLink.removeClass('dotted');
				compareLink.removeClass('current');

				products.removeClass('active');
				products.eq(index).addClass('active');

				new $$.Slider(products.eq(index).find('.js-slider'));

			});
		});

		$('.js-form-back').each(function () {
			$(this).validate({
				submitHandler: (form) => {
					form = $(form);

					$.ajax({
						url:     form.attr('action'),
						method:  form.attr('method'),
						data:    form.serialize(),
						success: (response) => {
							response = $.parseJSON(response);

							if (response.success) {
								$$.Noty[ 'successMessage' ](response.success);
							} else {
								_.each(response.errors, function (value, key) {
									var input = form.find(`input[name="${key}"]`).addClass('error');
									var error = $('<label class="error">' + value + '</label>');

									error.insertAfter(input);
								});
							}
						}
					});
				}
			});
		});

		$('.js-price-search').each(function () {
			var prices = $('.b-price-page .g-table .col-xs-5 a .text');

			$(this).on('input', function () {
				var input = $(this);

				var searchData = input.val().toLowerCase();

				if (searchData) {
					prices.parents('.row.body').removeClass('hidden');

					prices.filter((index, element) => {
						var priceItem = $(element);
						var priceItemName = priceItem.text().toLowerCase();

						var isValidStart = !_.startsWith(priceItemName, searchData);

						return isValidStart;
					}).parents('.row.body').addClass('hidden');
				} else {
					prices.parents('.row.body').removeClass('hidden');
				}
			});
		});

		$('.js-partner-price').each(function () {
			$(this).on('click', function () {
				$('html,body').animate({
					scrollTop: $('.js-partner-form').offset().top
				});
			});
		});

		$('.js-open-feedback').on('click', function (event) {
			event.preventDefault();

			$$.body.trigger('openfeedback');
		});
	}

	_fixIeFormButtons () {
		// detect if browser supports this
		var sampleElement = $('[form]').get(0);
		var isIE11 = !(window.ActiveXObject) && "ActiveXObject" in window;

		if (sampleElement && window.HTMLFormElement  && isIE11) {//&& sampleElement.form instanceof HTMLFormElement
			$.fn.appendField = function(data) {
				// for form only
				if (!this.is('form')) return;

				// wrap data
				if (!$.isArray(data) && data.name && data.value) {
					data = [data];
				}

				var $form = this;

				// attach new params
				$.each(data, function(i, item) {
					$('<input/>')
						.attr('type', 'hidden')
						.attr('name', item.name)
						.val(item.value).appendTo($form);
				});

				return $form;
			};

			/**
			 * Find all input fields with form attribute point to jQuery object
			 *
			 */
			$('form[id]').each(function() {
				var form = this,
					$form = $(form),
					$fields = $('[form=' + $form.attr('id') + ']');

				$fields.filter('.g-button').click(function() {
					$(form).appendField({name: this.name, value: this.value}).submit();
				});
			});
		}
	}

	noty (root) {
		var messages = root.find('.js-messages');

		var messagesData = messages.data();

		_.each(messagesData, function (value, key) {
			if (_.isBoolean(value)) {
				if (value) {
					$$.Noty[ key ]();
				}
			} else {
				var val = value.split('-');
				if (val[ 0 ] === 'true') {
					$$.Noty[ key ](val[ 1 ], val[ 2 ]);
				}
			}
		});
	}
}

$(function () {
		$$.window = $(window);
		$$.body = $(document.body);
		$$.windowWidth = $$.window.width();
		$$.windowHeight = $$.window.height();
		$$.initCountGoods = function () {
			"use strict";
			var Cart = $('.js-cart-small');

			var changeCount = {
				minus: function (count) {
					"use strict";

					return count <= 1 ? 1 : --count;
				},

				plus: function (count) {
					"use strict";

					return ++count;
				}
			};

			$('.js-count-goods').each(function () {
				var amount = $(this);

				if (amount.data('countGoodsEnabled')) {
					return;
				}

				amount.siblings('.js-add-to-cart').data('count', 1);

				var inputVal = amount.find('input').val();

				if (parseInt(inputVal) === 1) {
					amount.find('.minus').addClass('disable');
				} else {
					amount.find('.minus').removeClass('disable');
				}

				amount.on('click', 'a', (event) => {
					"use strict";
					event.preventDefault();

					var item = $(event.currentTarget);
					var input = item.siblings('input');
					var className = item.attr('class').split(' ')[ 0 ];

					input.val(changeCount[ className ](input.val()));

					amount.siblings('.js-add-to-cart').data('count', parseInt(input.val()));

					amount.find('input').trigger('change');
				});

				amount.on('change', 'input', (event) => {
					var input = $(event.currentTarget);
					let inputValue = parseInt(input.val());
					let minValue = parseInt(input.attr('min'));
					let maxValue = parseInt(input.attr('max'));

					if (inputValue < minValue) {
						input.val(minValue);
					}

					if (inputValue > maxValue) {
						input.val(maxValue);
					}

					if (amount.parents('.js-cart').length) {
						if (!amount.find('.minus').hasClass('disable')) {
							$.ajax({
								url:     $$.Config.updateCartUrl,
								method:  'POST',
								data:    {
									id:    amount.parents('.js-card').data('id'),
									count: parseInt(input.val())
								},
								success: (response) => {
									response = $.parseJSON(response);

									if (response.SUM) {
										amount.siblings('.price-wrapper').find('.price').text(response.SUM);
										Cart.find('.price').text(response.SUM_ALL);
										$('.js-sum-all').text(response.SUM_ALL);
										Cart.find('.count').text(response.COUNT);
									}
								},
								error:   (error) => {
									$$.Noty[ 'errorMessage' ](`${error.status} - ${error.statusText}`);
								}
							});
						}
					}

					if (parseInt(input.val()) === 1) {
						amount.find('.minus').addClass('disable');
					} else {
						amount.find('.minus').removeClass('disable');
					}
				});


				amount.on('keyup', 'input', (event) => {
					"use strict";

					var item = $(event.currentTarget);

					if (parseInt(item.val()) < 1) {
						item.val(1);
					}

					if (isNaN(parseInt(item.val()))) {
						item.val(1);
					}

					item.val(parseInt(item.val()));

					amount.siblings('.js-add-to-cart').data('count', parseInt(item.val()));
				});

				amount.siblings('.js-add-to-cart').on('click', (event) => {
					"use strict";

					event.preventDefault();

					var item = $(event.currentTarget);

					$.ajax({
						url:     $$.Config.addCartUrl,
						method:  'POST',
						data:    item.data(),
						success: (response) => {
							response = $.parseJSON(response);

							$$.Noty[ 'successMessage' ](`Добавлен товар - ${response.NAME}`);

							if (response.SUM_ALL) {
								Cart.find('.money .price').text(response.SUM_ALL);
								Cart.find('.money .count').text(response.COUNT);

								if (Cart.find('.money').hasClass('hidden')) {
									Cart.find('.empty-cart').addClass('hidden');
									Cart.find('.money').removeClass('hidden');
								}
							}
						},
						error:   (error) => {
							$$.Noty[ 'errorMessage' ](`${error.status} - ${error.statusText}`);
						}
					});
				});
			});
		};

		$$.application = new Application();

		$$.ESCAPE_KEY_CODE = 27;
		$('.p-content-wrapper').css({ minHeight: $$.window.height() - 60 });

		$$.window.on('resize', function () {
			$$.windowWidth = $$.window.width();
			$$.windowHeight = $$.window.height();
			$('.p-content-wrapper').css({ minHeight: $$.window.height() - 60 });
		});
	}
);

$(window).load(initAnalytics);
